// JavaScript Document

$(document).foundation();

$(window).load(function () {

  function fireGlobalForms() {

    function handleKeyUp(e) {
      
      var $input = $(e.currentTarget)
      var $label = $input.closest('.js-field').find('label').first()

      if ($input.val() === '' || $input.val() === null || !$input.val().length) {
        $label.removeClass('fly--active');
      } else {
        $label.addClass('fly--active');
      }
    }

    function moveLabel(e) {
      var $input = $(e.currentTarget),
        $label = $input.closest('.js-field').find('label').first();

      $label.addClass('fly--focus');
    }

    function handleBlur(e) {
      var $input = $(e.currentTarget)
      var $label = $input.closest('.js-field').find('label').first()

      $label.removeClass('fly--focus')
      handleKeyUp(e)
    }

    $('.js-bfr-form').on('keyup change', '.js-field input[type=text], .js-field input[type=tel], .js-field input[type=email], .js-field input[type=password], .js-field select', handleKeyUp);
    $('.js-bfr-form').on('focus', '.js-field input[type=text], .js-field input[type=tel], .js-field input[type=email], .js-field input[type=password], .js-field select', moveLabel);
    $('.js-bfr-form').on('blur', '.js-field input[type=text], .js-field input[type=tel], .js-field input[type=email], .js-field input[type=password], .js-field select', handleBlur);

    if ($('.js-field input').val().length > 0) {
      $('.js-field').find('label').addClass('fly--active');
    }

    $('.js-field input, .js-field select, .js-field textarea').each(
      function () {
        var val = $(this).val().trim();
        if (val.length) {
          $(this).closest('.js-field').find('label').addClass('fly--active');
        }
      });
  }

  function fireReviewForms() {

    function handleKeyUp(e) {
      var $input = $(e.currentTarget)
      var $label = $input.closest('div').find('label').first()

      if ($input.val() === '' || $input.val() === null || !$input.val().length) {
        $label.removeClass('fly--active');
      } else {
        $label.addClass('fly--active');
      }
    }

    function moveLabel(e) {
      var $input = $(e.currentTarget),
        $label = $input.closest('div').find('label').first();

      $label.addClass('fly--focus');
    }

    function handleBlur(e) {
      var $input = $(e.currentTarget)
      var $label = $input.closest('div').find('label').first()

      $label.removeClass('fly--focus')
      handleKeyUp(e)
    }

    $('.new-review-form').on('keyup change', '.spr-form-input-text, .spr-form-input-email', handleKeyUp);
    $('.new-review-form').on('focus', '.spr-form-input-text, .spr-form-input-email', moveLabel);
    $('.new-review-form').on('blur', '.spr-form-input-text, .spr-form-input-email', handleBlur);
  }

  $("#status").fadeOut();
  $("#preloader").delay(500).fadeOut("slow", function () {
    $('#preloader').addClass('is-hidden');

    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      $('body').addClass('is-firefox');
    } 
    else {
	  fireReviewForms();

      //if ($('.js-bfr-form').length) {
      //  fireGlobalForms();
      //}
    }
  });
  
  if ($('.js-bfr-form').length) {
    fireGlobalForms();
  }

});

if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
  $('body').addClass('is-firefox');
}

$('.open_search_box_cls').click(function () {
  setTimeout(function () {
    $('.search_popup_field').focus();
  }, 500);

});

/*---------   Sliders   ---------*/

$(document).ready(function (e) {

  $('.grid-1').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false
  });

  $('.grid-2').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.grid-3').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.grid-4').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.grid-5').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  $('.home1-slider ul').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    slide: 'li',
    responsive: [{
        breakpoint: 1024,
        settings: {
          centerPadding: '40px',
          variableWidth: false
        }
      },
      {
        breakpoint: 640,
        settings: {
          centerPadding: '0px',
          variableWidth: false
        }
      }
    ]
  });

  /*
	$('.home2-slider ul').slick({
	  //infinite: true,
	  arrows: true,
	  dots: false,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  slide: 'li',
	  autoplay: false
	});
	*/

  $('.home3-slider ul').slick({
    //infinite: true,
    arrows: false,
    dots: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false
  });

});

var grid_1_var, grid_2_var, grid_3_var, grid_4_var, grid_5_var, grid_6_var;

grid_1_var = $('.grid_1_flex_slider').width();
grid_2_var = $('.grid_2_flex_slider').width() / 2;
grid_3_var = $('.grid_3_flex_slider').width() / 3;
grid_4_var = $('.grid_4_flex_slider').width() / 4;
grid_5_var = $('.grid_5_flex_slider').width() / 5;
grid_6_var = $('.grid_6_flex_slider').width() / 6;

if ($(window).width() < 1024) {
  grid_1_var = $(window).width();
  grid_2_var = $(window).width() / 2;
  grid_3_var = $(window).width() / 2;
  grid_4_var = $(window).width() / 3;
  grid_5_var = $(window).width() / 3;
  grid_6_var = $(window).width() / 4;
}

if ($(window).width() < 768) {
  grid_1_var = $(window).width();
  grid_2_var = $(window).width() / 1;
  grid_3_var = $(window).width() / 2;
  grid_4_var = $(window).width() / 2;
  grid_5_var = $(window).width() / 2;
  grid_6_var = $(window).width() / 3;
}

if ($(window).width() < 568) {
  grid_1_var = $(window).width();
  grid_2_var = $(window).width();
  grid_3_var = $(window).width();
  grid_4_var = $(window).width();
  grid_5_var = $(window).width();
  grid_6_var = $(window).width() / 2;
}

var grid_1_code = $('.grid_1_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_1_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 1,
  touch: true,
  slideshow: false,
  move: 1
});

var grid_2_code = $('.grid_2_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_2_var,

  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 2,
  touch: true,
  slideshow: false,
  move: 1
});

var grid_3_code = $('.grid_3_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_3_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 3,
  touch: true,
  slideshow: false,
  move: 1
});

var grid_4_code = $('.grid_4_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_4_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 4,
  touch: true,
  slideshow: false,
  move: 1
});

var grid_5_code = $('.grid_5_flex_slider').flexslider({
  animation: "slide",
  animationLoop: false,
  controlNav: false,
  itemWidth: grid_5_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 1,
  maxItems: 5,
  touch: true,
  slideshow: false,
  move: 1
});

var grid_6_code = $('.grid_6_flex_slider').flexslider({
  animation: "slide",
  animationLoop: true,
  controlNav: false,
  itemWidth: grid_6_var,
  nextText: "",
  prevText: "",
  itemMargin: 0,
  minItems: 2,
  maxItems: 6,
  touch: true,
  slideshow: true,
  move: 1
});

var home_slider_code = $('.home-slider').slick({
  speed: 1200,
  slidesToShow: 1,
  arrows: true,
  dots: true,
  touchMove: false,
  slide: 'li',
  //fade:true,
  autoplay: false,
  //infinite:false,
  dotsClass: 'custom-paging',
  customPaging: function (slider, i) {
    return '0' + (i + 1) + ' ' + '<span>' + '/' + ' ' + '0' + slider.slideCount + '</span>';
  }
});

$(window).load(function () {
  grid_1_code.load();
  grid_2_code.load();
  grid_3_code.load();
  grid_4_code.load();
  grid_5_code.load();
  grid_6_code.load();
  home_slider_code.load();

  setTimeout(function () {
    grid_1_code.resize();
    grid_2_code.resize();
    grid_3_code.resize();
    grid_4_code.resize();
    grid_5_code.resize();
    grid_6_code.resize();
    home_slider_code.resize();
  }, 500);
});

function grid_function_custom() {
  var grid_1_var, grid_2_var, grid_3_var, grid_4_var, grid_5_var, grid_6_var;
  grid_1_var = $('.grid_1_flex_slider').width();
  grid_2_var = $('.grid_2_flex_slider').width() / 2;
  grid_3_var = $('.grid_3_flex_slider').width() / 3;
  grid_4_var = $('.grid_4_flex_slider').width() / 4;
  grid_5_var = $('.grid_5_flex_slider').width() / 5;
  grid_6_var = $('.grid_6_flex_slider').width() / 6;

  var grid_1_code = $('.grid_1_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_1_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 2,
    touch: true,
    slideshow: false,
    move: 1
  });

  var grid_2_code = $('.grid_2_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_2_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 2,
    touch: true,
    slideshow: false,
    move: 1
  });

  var grid_3_code = $('.grid_3_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_3_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 3,
    touch: true,
    slideshow: false,
    move: 1
  });

  var grid_4_code = $('.grid_4_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_4_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 4,
    touch: true,
    slideshow: false,
    move: 1
  });

  var grid_5_code = $('.grid_5_flex_slider').flexslider({
    animation: "slide",
    animationLoop: false,
    controlNav: false,
    itemWidth: grid_5_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 1,
    maxItems: 5,
    touch: true,
    slideshow: false,
    move: 1
  });

  var grid_6_code = $('.grid_6_flex_slider').flexslider({
    animation: "slide",
    animationLoop: true,
    controlNav: false,
    itemWidth: grid_6_var,
    nextText: "",
    prevText: "",
    itemMargin: 0,
    minItems: 2,
    maxItems: 6,
    touch: true,
    slideshow: true,
    move: 1
  });

  var home_slider_code = $('.home-slider').slick({
    speed: 1200,
    slidesToShow: 1,
    arrows: true,
    dots: true,
    touchMove: false,
    slide: 'li',
    //fade:true,
    autoplay: false,
    //infinite:false,
    dotsClass: 'custom-paging',
    customPaging: function (slider, i) {
      return '0' + (i + 1) + ' ' + '<span>' + '/' + ' ' + '0' + slider.slideCount + '</span>';
    }
  });

  grid_1_code.load();
  grid_2_code.load();
  grid_3_code.load();
  grid_4_code.load();
  grid_5_code.load();
  grid_6_code.load();
  home_slider_code.load();

  setTimeout(function () {
    grid_1_code.resize();
    grid_2_code.resize();
    grid_3_code.resize();
    grid_4_code.resize();
    grid_5_code.resize();
    grid_6_code.resize();
    home_slider_code.resize();
  }, 500);
}

/*---------   Tab Slick   ---------*/

$(document).ready(function (e) {

  $('.tab-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    slide: 'li',
    autoplay: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.decrease-qty').on('click', function () {
    var count = $(this).siblings(".product_qty_input");
    var val = parseInt(count.val());
    if (val > 1)
      count.val(val - 1);
  });
  $('.increase-qty').on('click', function () {
    var count = $(this).siblings(".product_qty_input");
    var val = parseInt(count.val());
    count.val(val + 1);
  });

  $(".product-tab .tabs-title>a").click(function (event) {

    event.preventDefault();
    $('.tab-slider').slick("unslick");

    var tab = $(this).attr("href");
    $(tab).fadeIn();
    $(".tabs-panel").not(tab).css("display", "none");

    $('.tab-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      slide: 'li',
      autoplay: false,
      responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 568,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

  });

});

/*---------   Mobile Menu   ---------*/

$('header .menu-icon, .side-menu .close-button').click(function (e) {
  $(".app-container").toggleClass("expanded");
});

$('.menu-icon').click(function (e) {
  $(".productbar-wrap").slideToggle();
});
$('.submenu-parent').each(function (index, element) {
  $(this).append('<span></span>');
});

$('.submenu-parent span').on('click', function (e) {

  var submenu = $(this).closest('.submenu-parent').find('>.sub-menu');

  if (submenu.is(":visible") == true) {

    submenu.slideUp();
    $(this).closest('.submenu-parent').removeClass('active');

  } else {
    //$('.submenu-parent>ul.sub-menu').removeClass('active').slideUp();	
    submenu.slideDown();
    $(this).closest('.submenu-parent').addClass('active');

  }

  e.preventDefault();
});

$('.sub-menu .submenu-parent span').on('click', function (e) {

  var grandsubmenu = $(this).closest('.submenu-parent').find('>.grand-submenu');

  if (grandsubmenu.is(":visible") == true) {

    grandsubmenu.slideUp();
    $(this).closest('.submenu-parent').removeClass('active');
  } else {

    //$('.submenu-parent > ul.grand-submenu').removeClass('active').slideUp();	
    grandsubmenu.slideDown();
    $(this).closest('.submenu-parent').addClass('active');

    if ($(this).closest('.submenu-parent').hasClass('active')) {

      $(this).closest('.sub-menu').slideDown();

    } else {
      // $(this).closest('.sub-menu').slideUp();

    }
  }
  e.preventDefault();

});
/*---------   Header Fix   ---------*/

$(window).scroll(function () {
  if ($(this).scrollTop() >= 1) {
    $('.main-header').addClass('stickytop');
  } else {
    $('.main-header').removeClass('stickytop');
  }
});
/*---------   Slider Img In Bg   ---------*/

$(window).load(function (e) {

  jQuery('.slider-img').each(function () {

    var el = $(this),
      src = el.attr('src'),
      parent = el.parent();
    height = $(window).height() - $('header').innerHeight();

    parent.css({
      'background-image': 'url(' + src + ')',
      'background-size': 'cover',
      'background-position': 'center',
      'height': height
    });

    el.hide();
  });

  jQuery('.bg-img').each(function () {

    var el = $(this),
      src = el.attr('src'),
      parent = el.parent();
    height = $(this).height();

    parent.css({
      'background-image': 'url(' + src + ')',
      'background-size': 'cover',
      'background-position': 'center',
      'height': height
    });

    el.hide();
  });

  /*
     var wow = new WOW(
       {
         boxClass:     'wow',      // animated element css class (default is wow)
         animateClass: 'animated', // animation css class (default is animated)
         offset:       100,          // distance to the element when triggering the animation (default is 0)
         mobile:       true,       // trigger animations on mobile devices (default is true)
         live:         true,       // act on asynchronously loaded content (default is true)
         callback:     function(box) {
           // the callback is fired every time an animation is started
           // the argument that is passed in is the DOM node being animated
         },
         scrollContainer: null // optional scroll container selector, otherwise use window
       }
     );
     wow.init();
   */

});

/*---------   Counter   ---------*/

var end_day_sale_date_1 = $('.end_day_sale_date_1').attr('data-date');
var end_day_sale_date_2 = $('.end_day_sale_date_2').attr('data-date');

$(window).load(function () {
  $('#counter_desk').countdowntimer({
    dateAndTime: end_day_sale_date_1,
    size: "lg",
    regexpMatchFormat: "([0-9]{1,3}):([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})",
    regexpReplaceWith: "<span class='displayformat'>$1<p>Days</p></span><span class='displayformat'>$2<p>Hours</p></span><span class='displayformat'>$3<p>Mins</p></span><span class='displayformat'>$4<p>Secs</p></span>"
  });

  $('#counter_mobile').countdowntimer({
    dateAndTime: end_day_sale_date_1,
    size: "lg",
    regexpMatchFormat: "([0-9]{1,3}):([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})",
    regexpReplaceWith: "<span class='displayformat'>$1<p>Days</p></span><span class='displayformat'>$2<p>Hours</p></span><span class='displayformat'>$3<p>Mins</p></span><span class='displayformat'>$4<p>Secs</p></span>"
  });

  $('#white_counter').countdowntimer({
    dateAndTime: end_day_sale_date_2,
    size: "lg",
    regexpMatchFormat: "([0-9]{1,3}):([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})",
    regexpReplaceWith: "<span class='displayformat'>$1<p>Days</p></span><span class='displayformat'>$2<p>Hours</p></span><span class='displayformat'>$3<p>Mins</p></span><span class='displayformat'>$4<p>Secs</p></span>"
  });
});
$(document).ready(function (e) {
  var $html = $('html');

  function setupSearch() {
    //     $('.js-search-action').on('click', function(e) {
    var $search = $(this).closest('.site-nav__search')
    $html.toggleClass('js-search-opened')

    if ($html.hasClass('js-search-opened')) {
      setTimeout(function () {
        $search.find('input').focus()
      }, 600)
    } else {
      $search.find('input').val(null).blur()
    }
    //     })
  }

  setupSearch();

  $('.js-featured-products').slick({
    prevArrow: $('.js-bfr-prev-arrow'),
    nextArrow: $('.js-bfr-next-arrow'),
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.js-blog-slider').slick({
    prevArrow: $('.js-bfr-prev-arrow-blog'),
    nextArrow: $('.js-bfr-next-arrow-blog'),
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });

  function setupVideoPopups() {
    var $popups = $('.js-video-popup')
    // console.log($popups.length);

    if (!$popups.length) {
      return
    }
    
    $('.js-video-popup').magnificPopup({
      type: 'iframe'
    });
    

//     $(document).magnificPopup({
//       delegate: '.js-video-popup',
//       type: 'iframe',
//       closeOnBgClick: false
//     })
  }
  
  setupVideoPopups();

  function setupImagePopups() {
    var $popups = $('.js-image-popup')

    if (!$popups.length) {
      return
    }

    $(document).magnificPopup({
      delegate: '.js-image-popup',
      type: 'image',
      // closeOnBgClick: false
    })
  }
  setupImagePopups();

  function setupFAQ() {

    function setupToggle() {
      var $current
      var $this
      $(document).on('click', '.js-faq-question', function (e) {
        $current = $(e.currentTarget).closest('.js-faq-item').find('.js-faq-answer').slideToggle(100)
        $this = $(e.currentTarget);
        slideUpAnswer()
        if ($this.closest('.js-faq-item').hasClass('is-active')) {
          $this.closest('.js-faq-item').removeClass('is-active');
        } else {
          $this.closest('.js-faq-item').toggleClass('is-active');
        }
      })

      function slideUpAnswer() {
        $('.js-faq-answer').not($current).slideUp();
        $('.js-faq-answer').not($current).closest('.js-faq-item.is-active').removeClass('is-active');
      }
    }

    setupToggle();

  }

  setupFAQ();

// Manage tabs for company and product reviews
$(function(){
  jQuery('#tabs').createTabs({
		children: 'section',
		childrenTitle: 'h3'
  });

  // // Add anchor tag for Product Reviews
  // $('#tab-product-reviews').on('click', function(event) {
  //   event.preventDefault();
  //   window.location.hash = "product-reviews"
  // });

  // // Add anchor tag for Company Reviews
  // $('#tab-company-reviews').on('click', function(event) {
  //   event.preventDefault();
  //   window.location.hash = "company-reviews"
  // });
});

// Display data using the parsed JSON product_reviews file
$(function(){
  $.getJSON( "https:////www.foodsupplementsmarket.com/cdn/shop/t/47/assets/product_reviews.json?v=103254898472984871841781201438", function( data ) {
    var items = [];
    $.each( data, function( key, val ) {
      
      // Get consume name and extract initials
      let name = val.consumer_name;
      function getInitials(name) {
          var cleanedName = name.replace(/\([^()]*\)/g, '');
          var parts = cleanedName.split(' ');
          var initials = '';
          
          if (parts.length > 1) {
              initials = parts[0].charAt(0) + parts[parts.length - 1].charAt(0);
          } else {
              initials = parts[0].charAt(0);
          }
          
          return initials.toUpperCase();
      }
      var initials = getInitials(name);

      // Dynamically add stars
      let starsValue = val.stars;
      let stars = '';
      $(function() {
        for (let i = 1; i <= 5; i++) {
            if (i <= starsValue) {
                stars += '★';
            } else {
                stars += '☆';
            }
        }
        return stars;
      });

      // Format the date to mm/dd/yyyy
      let originalDate = val.created_at;
      var dateObj = new Date(originalDate);
      var month = dateObj.getUTCMonth() + 1;
      var day = dateObj.getUTCDate();
      var year = dateObj.getUTCFullYear();
      var date = (month < 10 ? '0' : '') + month + '/' + (day < 10 ? '0' : '') + day + '/' + year;

      let productName = val.product_name;
      let comment = val.content;

      items.push(
        `<li class="bfr-testimonials__item js-show-item">
            <div class="bfr-testimonials__item-inner">
              <div class="bfr-testimonial-author">
                <h2 class="bfr-testimonial-author__title">
                  <span class="initials">${initials}</span>${name}
                </h2>
              </div>
              <div class="bfr-testimonial-content">
                <p class="stars">
                  <span>${stars} <span></span></span>
                </p>
                <div class="bfr-testimonial-author__title">${productName}</div>
                <p class="comment">${comment}</p>
                <p class="date">${date}</p>
              </div>
            </div>
          </li>`
      );
    });
   
    $( "<ul/>", {
      "class": "bfr-testimonials__list",
      html: items.join( "" )
    }).appendTo( "#reviews-holder" );

    handleDynamicReviews();
    truncate();
    
  });
});
  
function handleDynamicReviews() {
  var speed = 500;
  var shown = 0;
  var increment = 20; // Value to increment the list amount by
  var maxShow = 20; // Initial display amount

  // Dynamic reviews for tabs
  $(".reviews-container").each(function() {
    var id = $(this).attr('id');
    
    $('#' + id + ' .js-show-item:lt(' + maxShow + ')').addClass('is-shown');
  
    var startCount = $('#' + id + ' .js-show-item.is-shown').length;
    var totalCount = $('#' + id + ' .js-show-item').length;
    var $hiddenItem = $('#' + id + ' .js-show-item').not('.is-shown');

    function setCounts() {
      $('#' + id + ' .js-active-item-count').text(startCount);
      $('#' + id + ' .js-active-item-total').text(totalCount);
      $('#' + id + ' .js-counter-set.js-active').text(totalCount);
    }
  
    setCounts();

    if (startCount == totalCount) {
      $('#' + id + ' .show-more-action-wrapper').hide();
    }

    // Show more reviews on button click
    $('#' + id + ' .js-show-more-items').on('click', function (e) {
      e.preventDefault();
      var counter = Math.min(increment, $hiddenItem.length - shown);
    
      var count = shown;
      shown += counter;
      maxShow += counter;
  
      // Show the next batch of items
      $hiddenItem.slice(count, shown).fadeIn(speed);
  
      $('#' + id + ' .js-active-item-count.js-active').text(maxShow);
  
      if (maxShow >= totalCount) {
        $(this).css('display', 'none');
        $('#' + id + ' .js-show-less-items.js-active').css('display', 'flex');
      }
      return false;
    });

    // Hide reviews on button click
    $('#' + id + ' .js-show-less-items').on('click', function (e) {
      var location = $(this).closest('.js-scroll-to');
      var headerHeight = $('#shopify-section-header-3').outerHeight();
  
      e.preventDefault();
      $(this).css('display', 'none');
      shown = 0;
      maxShow = 20;
      
      $('#' + id + ' .js-show-more-items.js-active').css('display', 'flex');
      $("html, body").animate(
        {
          scrollTop: location.offset().top - headerHeight
        }, 
        "slow",
        "linear",
        function() {
          $hiddenItem.css('display', 'none');
          setCounts();
        }
      );
      return false;
    });
    
  });  
}

// Truncate large review comments and enable jquery expander plugin
function truncate(){
  $('.bfr-testimonial-content .comment').expander({
    slicePoint: 300,
    expandText:'Read More',
    userCollapseText:'Read Less',
    preserveWords:true,
    detailPrefix:' ',
    expandEffect:'fadeIn',
    collapseEffect:'fadeOut',
  });
}

function blogLandingFunctions() {
    var $action = $('.js-blog-subscribe');
    var $subscribeWrapper = $('.js-subscribe-wrapper');
    var $subscribeForm = $('.js-subscribe-form');

    function showSubscribeForm() {
      if ($subscribeWrapper.hasClass('form-active')) {
        return
      } else {
        $subscribeWrapper.find($subscribeForm).slideDown(500, function () {
          $subscribeWrapper.addClass('form-active');
        });
      }
    }

    $action.on('click', showSubscribeForm);

  }

  if ($('.bfr-blog').length) {
    blogLandingFunctions();
  }
});